import React from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { XCircleIcon } from "@heroicons/react/24/solid";

const PaymentFailed = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderId = searchParams.get("orderId");

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-orange-50 flex items-center justify-center px-4 py-12">
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-xl border border-gray-100 p-8 text-center relative overflow-hidden">
        {/* Top red accent bar */}
        <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-red-500 to-rose-500" />

        {/* Failed Icon */}
        <div className="mx-auto flex items-center justify-center w-20 h-20 bg-red-100 rounded-full mb-5">
          <XCircleIcon className="w-14 h-14 text-red-600" />
        </div>

        {/* Heading */}
        <h1 className="text-3xl font-extrabold text-gray-800 tracking-tight">
          Payment Failed, Please Try Again
        </h1>
        <p className="mt-2 text-gray-600 text-sm">
          Your transaction could not be completed or was cancelled by the payment gateway.
        </p>

        {/* Order ID Box */}
        {orderId && (
          <div className="mt-6 bg-gray-50 border border-gray-200 rounded-xl p-4 flex flex-col sm:flex-row items-center justify-between gap-3">
            <div className="text-left">
              <span className="text-xs uppercase font-semibold text-gray-400 block">
                Order ID
              </span>
              <span className="text-lg font-bold text-gray-800 font-mono">
                {orderId}
              </span>
            </div>
          </div>
        )}

        {/* Reassurance box */}
        <div className="mt-6 text-left bg-amber-50 border border-amber-200 rounded-xl p-4 text-xs text-amber-900 space-y-2">
          <p className="font-semibold text-amber-950">
            ℹ️ Did your money get deducted?
          </p>
          <p>
            Don't worry! If your account was debited, the amount will automatically be reversed by your bank within 5–7 working days.
          </p>
        </div>

        {/* Actions */}
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <button
            onClick={() => navigate("/Getaddress")}
            className="flex-1 py-3 px-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-xl shadow-md transition duration-200"
          >
            Try Payment Again
          </button>
          <button
            onClick={() => navigate("/Cart")}
            className="flex-1 py-3 px-4 bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold rounded-xl transition duration-200"
          >
            Review Cart
          </button>
        </div>

        {/* Home link */}
        <div className="mt-4">
          <Link
            to="/"
            className="text-xs text-gray-500 hover:text-orange-600 font-medium transition underline"
          >
            Return to Homepage
          </Link>
        </div>

        {/* Help & Support */}
        <div className="mt-6 pt-6 border-t border-gray-100 text-xs text-gray-500">
          Need help? Contact our customer support team at{" "}
          <a
            href="mailto:info@bharatcod.com"
            className="text-orange-600 font-semibold hover:underline"
          >
            info@bharatcod.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
